<template>
  <form @submit.prevent="submitForm">

    <div class="mb-3">
      <label class="form-label">
        Book Name
      </label>

      <input
        v-model.trim="form.name"
        type="text"
        class="form-control"
        required
      >
    </div>

    <div class="mb-3">
      <label class="form-label">
        ISBN
      </label>

      <input
        v-model.trim="form.ISBN"
        type="text"
        class="form-control"
        required
      >
    </div>

    <div class="row">

      <div class="col-md-6 mb-3">
        <label class="form-label">
          Category
        </label>

        <input
          v-model.trim="form.category"
          type="text"
          class="form-control"
          required
        >
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">
          Author
        </label>

        <input
          v-model.trim="form.author"
          type="text"
          class="form-control"
          required
        >
      </div>

    </div>

    <div class="row">

      <div class="col-md-6 mb-3">
        <label class="form-label">
          Pages
        </label>

        <input
          v-model.number="form.pages"
          type="number"
          min="1"
          class="form-control"
          required
        >
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">
          Price
        </label>

        <input
          v-model.number="form.price"
          type="number"
          min="0"
          class="form-control"
          required
        >
      </div>

    </div>

    <div class="mb-3">
      <label class="form-label">
        Image URL
      </label>

      <input
        v-model.trim="form.image"
        type="url"
        class="form-control"
        required
      >
    </div>

    <button
      type="submit"
      class="btn btn-success me-2"
    >
      {{ submitText }}
    </button>

    <router-link
      to="/books"
      class="btn btn-secondary"
    >
      Cancel
    </router-link>

  </form>
</template>

<script>
export default {
  name: 'BookForm',

  props: {
    initialBook: {
      type: Object,
      default: null
    },

    submitText: {
      type: String,
      default: 'Save Book'
    }
  },

  data() {
    return {
      form: {
        name: '',
        ISBN: '',
        category: '',
        image: '',
        pages: 1,
        author: '',
        price: 0
      }
    }
  },

  mounted() {
    if (this.initialBook) {
      this.form = {
        ...this.initialBook
      }
    }
  },

  methods: {
    submitForm() {
      this.$emit(
        'submit',
        {
          ...this.form
        }
      )
    }
  }
}
</script>